// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_RevMap = require("../Data.RevMap/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Framework_Direction = require("../Framework.Direction/index.js");
var Random_Gen = require("../Random.Gen/index.js");
var Hp = (function () {
    function Hp() {

    };
    Hp.value = new Hp();
    return Hp;
})();
var PlayerHeartLarge = (function () {
    function PlayerHeartLarge() {

    };
    PlayerHeartLarge.value = new PlayerHeartLarge();
    return PlayerHeartLarge;
})();
var HumanEye = (function () {
    function HumanEye() {

    };
    HumanEye.value = new HumanEye();
    return HumanEye;
})();
var EyeRed = (function () {
    function EyeRed() {

    };
    EyeRed.value = new EyeRed();
    return EyeRed;
})();
var EyeBlue = (function () {
    function EyeBlue() {

    };
    EyeBlue.value = new EyeBlue();
    return EyeBlue;
})();
var EyeHoriz = (function () {
    function EyeHoriz() {

    };
    EyeHoriz.value = new EyeHoriz();
    return EyeHoriz;
})();
var EyeVert = (function () {
    function EyeVert() {

    };
    EyeVert.value = new EyeVert();
    return EyeVert;
})();
var Armor = (function () {
    function Armor() {

    };
    Armor.value = new Armor();
    return Armor;
})();
var OrganSize = (function () {
    function OrganSize(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OrganSize.create = function (value0) {
        return function (value1) {
            return new OrganSize(value0, value1);
        };
    };
    return OrganSize;
})();
var Organ = (function () {
    function Organ(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Organ.create = function (value0) {
        return function (value1) {
            return new Organ(value0, value1);
        };
    };
    return Organ;
})();
var HpClue = (function () {
    function HpClue(value0) {
        this.value0 = value0;
    };
    HpClue.create = function (value0) {
        return new HpClue(value0);
    };
    return HpClue;
})();
var ArmorClue = (function () {
    function ArmorClue(value0) {
        this.value0 = value0;
    };
    ArmorClue.create = function (value0) {
        return new ArmorClue(value0);
    };
    return ArmorClue;
})();
var MixedClue = (function () {
    function MixedClue(value0) {
        this.value0 = value0;
    };
    MixedClue.create = function (value0) {
        return new MixedClue(value0);
    };
    return MixedClue;
})();
var ConcealedClue = (function () {
    function ConcealedClue() {

    };
    ConcealedClue.value = new ConcealedClue();
    return ConcealedClue;
})();
var EmptyClue = (function () {
    function EmptyClue() {

    };
    EmptyClue.value = new EmptyClue();
    return EmptyClue;
})();
var Board = function (x) {
    return x;
};
var Health = function (x) {
    return x;
};
var restrictClue = function (v) {
    return function (c) {
        var req = function (v1) {
            return function (x) {
                if (v1) {
                    return x;
                };
                if (!v1) {
                    return ConcealedClue.value;
                };
                throw new Error("Failed pattern match at Data.Board (line 206, column 3 - line 206, column 17): " + [ v1.constructor.name, x.constructor.name ]);
            };
        };
        var go = function (v1) {
            if (v1 instanceof HpClue) {
                return req(v.canSee)(c);
            };
            if (v1 instanceof ArmorClue) {
                return req(v.hasSpecialEyes)(c);
            };
            if (v1 instanceof MixedClue) {
                return req(v.canSee && v.hasSpecialEyes)(c);
            };
            return c;
        };
        return go(c);
    };
};
var randomUninjuredSpace = function (v) {
    var cart = Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(5))(function (x) {
        return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(5))(function (y) {
            return Control_Applicative.pure(Control_Applicative.applicativeArray)({
                x: x,
                y: y
            });
        });
    });
    var uninjured = Data_Array.filter(function (x) {
        return !Data_Set.member(Extra_Math.ordVector(Data_Ord.ordInt))(x)(v.injuries);
    })(cart);
    var v1 = Data_Array_NonEmpty.fromArray(uninjured);
    if (v1 instanceof Data_Maybe.Nothing) {
        return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Maybe.Nothing.value);
    };
    if (v1 instanceof Data_Maybe.Just) {
        return Data_Functor.map(Random_Gen.functorRandom)(Data_Maybe.Just.create)(Random_Gen.element(v1.value0));
    };
    throw new Error("Failed pattern match at Data.Board (line 223, column 7 - line 225, column 37): " + [ v1.constructor.name ]);
};
var randomInjuredSpace = function (v) {
    return (function (v1) {
        if (v1 instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Random_Gen.applicativeRandom)(Data_Maybe.Nothing.value);
        };
        if (v1 instanceof Data_Maybe.Just) {
            return Data_Functor.map(Random_Gen.functorRandom)(Data_Maybe.Just.create)(Random_Gen.element(v1.value0));
        };
        throw new Error("Failed pattern match at Data.Board (line 231, column 5 - line 233, column 40): " + [ v1.constructor.name ]);
    })(Data_Array_NonEmpty.fromArray(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(v.injuries)));
};
var organAt = Data_RevMap.lookup(Extra_Math.ordVector(Data_Ord.ordInt));
var organArray = Data_RevMap.uniqueValues(Extra_Math.ordVector(Data_Ord.ordInt));
var newtypeHealth = new Data_Newtype.Newtype(function (n) {
    return n;
}, Health);
var newtypeBoard = new Data_Newtype.Newtype(function (n) {
    return n;
}, Board);
var isValidBoardCoord = function (v) {
    return v.x >= 0 && (v.x <= 5 && (v.y >= 0 && v.y <= 5));
};
var isRedEye = function (v) {
    if (v.value1 instanceof HumanEye) {
        return true;
    };
    if (v.value1 instanceof EyeRed) {
        return true;
    };
    return false;
};
var isInside = function (v) {
    return function (v1) {
        return v1.value1.x <= v.x && (v.x < (v1.value1.x + v1.value0.value0.value0 | 0) && (v1.value1.y <= v.y && v.y < (v1.value1.y + v1.value0.value0.value1 | 0)));
    };
};
var isInjured = function (v) {
    return function (v1) {
        return Data_Set.member(Extra_Math.ordVector(Data_Ord.ordInt))(v)(v1.board.injuries);
    };
};
var validTarget = function (v) {
    return function (h) {
        return isValidBoardCoord(v) && !isInjured(v)(h);
    };
};
var isHpOrgan = function (v) {
    if (v.value1 instanceof Hp) {
        return true;
    };
    if (v.value1 instanceof PlayerHeartLarge) {
        return true;
    };
    return false;
};
var isBlueEye = function (v) {
    if (v.value1 instanceof EyeBlue) {
        return true;
    };
    return false;
};
var isArmorOrgan = function (v) {
    if (v.value1 instanceof Armor) {
        return true;
    };
    return false;
};
var isAlive = function (v) {
    return v.hpCount > 0;
};
var injureBoard = function (v) {
    return function (v1) {
        return {
            organs: v1.organs,
            injuries: Data_Set.insert(Extra_Math.ordVector(Data_Ord.ordInt))(v)(v1.injuries)
        };
    };
};
var i = function (base) {
    return function (hurt) {
        return {
            base: base,
            hurt: hurt
        };
    };
};
var organImages = function (v) {
    if (v instanceof Hp) {
        return i("heart.png")("injuredheart.png");
    };
    if (v instanceof PlayerHeartLarge) {
        return i("Heart4.png")("Heart4injured.png");
    };
    if (v instanceof HumanEye) {
        return i("Eye1.png")("Eye1Hurt.png");
    };
    if (v instanceof EyeRed) {
        return i("Eye2.png")("Eye2Hurt.png");
    };
    if (v instanceof EyeBlue) {
        return i("Eye3.png")("Eye3Hurt.png");
    };
    if (v instanceof EyeHoriz) {
        return i("Eye4.png")("Eye4Hurt.png");
    };
    if (v instanceof EyeVert) {
        return i("Eye5.png")("Eye5Hurt.png");
    };
    if (v instanceof Armor) {
        return i("Armor5.png")("Armor5Hurt.png");
    };
    throw new Error("Failed pattern match at Data.Board (line 26, column 1 - line 26, column 63): " + [ v.constructor.name ]);
};
var getOrgans = function (v) {
    var noInjuries = function (v1) {
        var ymax = (v1.value1.y + v1.value0.value0.value1 | 0) - 1 | 0;
        var xmax = (v1.value0.value0.value0 + v1.value1.x | 0) - 1 | 0;
        return !Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (v2) {
            return v2.x >= v1.value1.x && (v2.x <= xmax && (v2.y >= v1.value1.y && v2.y <= ymax));
        })(v.injuries);
    };
    var v1 = Data_Array.partition(noInjuries)(organArray(v.organs));
    return {
        intact: v1.yes,
        injured: v1.no
    };
};
var intactOrgans = function (board) {
    return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)((getOrgans(board)).intact);
};
var getOrganAtPosition = function (v) {
    return function (p) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.fst)(organAt(p)(v.organs));
    };
};
var getClue = function (p) {
    return function (b) {
        var neighbors = Data_Array.filter(isValidBoardCoord)(Control_Apply.apply(Control_Apply.applyArray)(Data_Functor.map(Data_Functor.functorArray)(Framework_Direction.move(Data_Ring.ringInt))(Framework_Direction.directions8))(Control_Applicative.pure(Control_Applicative.applicativeArray)(p)));
        var hpOrgans = Data_Array.length(Data_Array.filter(isHpOrgan)(Data_Array.mapMaybe(getOrganAtPosition(b))(neighbors)));
        var armorOrgans = Data_Array.length(Data_Array.filter(isArmorOrgan)(Data_Array.mapMaybe(getOrganAtPosition(b))(neighbors)));
        var v = armorOrgans > 0;
        var v1 = hpOrgans > 0;
        if (v1 && !v) {
            return new HpClue(hpOrgans);
        };
        if (!v1 && v) {
            return new ArmorClue(armorOrgans);
        };
        if (v1 && v) {
            return new MixedClue(armorOrgans + hpOrgans | 0);
        };
        if (!v1 && !v) {
            return EmptyClue.value;
        };
        throw new Error("Failed pattern match at Data.Board (line 151, column 7 - line 155, column 34): " + [ v1.constructor.name, v.constructor.name ]);
    };
};
var extent = function (v) {
    return function (pos) {
        return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(v.value0.value0 - 1 | 0))(function (x) {
            return Control_Bind.bind(Control_Bind.bindArray)(Data_Array.range(0)(v.value0.value1 - 1 | 0))(function (y) {
                return Control_Applicative.pure(Control_Applicative.applicativeArray)(Data_Semiring.add(Extra_Math.semiringVector(Data_Semiring.semiringInt))(pos)({
                    x: x,
                    y: y
                }));
            });
        });
    };
};
var eqOrganType = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Hp && y instanceof Hp) {
            return true;
        };
        if (x instanceof PlayerHeartLarge && y instanceof PlayerHeartLarge) {
            return true;
        };
        if (x instanceof HumanEye && y instanceof HumanEye) {
            return true;
        };
        if (x instanceof EyeRed && y instanceof EyeRed) {
            return true;
        };
        if (x instanceof EyeBlue && y instanceof EyeBlue) {
            return true;
        };
        if (x instanceof EyeHoriz && y instanceof EyeHoriz) {
            return true;
        };
        if (x instanceof EyeVert && y instanceof EyeVert) {
            return true;
        };
        if (x instanceof Armor && y instanceof Armor) {
            return true;
        };
        return false;
    };
});
var ordOrganType = new Data_Ord.Ord(function () {
    return eqOrganType;
}, function (x) {
    return function (y) {
        if (x instanceof Hp && y instanceof Hp) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Hp) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Hp) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof PlayerHeartLarge && y instanceof PlayerHeartLarge) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof PlayerHeartLarge) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof PlayerHeartLarge) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof HumanEye && y instanceof HumanEye) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof HumanEye) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof HumanEye) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof EyeRed && y instanceof EyeRed) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof EyeRed) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof EyeRed) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof EyeBlue && y instanceof EyeBlue) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof EyeBlue) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof EyeBlue) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof EyeHoriz && y instanceof EyeHoriz) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof EyeHoriz) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof EyeHoriz) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof EyeVert && y instanceof EyeVert) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof EyeVert) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof EyeVert) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Armor && y instanceof Armor) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Data.Board (line 50, column 1 - line 50, column 46): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var eqOrganSize = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x.value0 === y.value0 && x.value1 === y.value1;
    };
});
var ordOrganSize = new Data_Ord.Ord(function () {
    return eqOrganSize;
}, function (x) {
    return function (y) {
        var v = Data_Ord.compare(Data_Ord.ordInt)(x.value0)(y.value0);
        if (v instanceof Data_Ordering.LT) {
            return Data_Ordering.LT.value;
        };
        if (v instanceof Data_Ordering.GT) {
            return Data_Ordering.GT.value;
        };
        return Data_Ord.compare(Data_Ord.ordInt)(x.value1)(y.value1);
    };
});
var eqOrgan = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(eqOrganSize)(x.value0)(y.value0) && Data_Eq.eq(eqOrganType)(x.value1)(y.value1);
    };
});
var ordOrgan = new Data_Ord.Ord(function () {
    return eqOrgan;
}, function (x) {
    return function (y) {
        var v = Data_Ord.compare(ordOrganSize)(x.value0)(y.value0);
        if (v instanceof Data_Ordering.LT) {
            return Data_Ordering.LT.value;
        };
        if (v instanceof Data_Ordering.GT) {
            return Data_Ordering.GT.value;
        };
        return Data_Ord.compare(ordOrganType)(x.value1)(y.value1);
    };
});
var insertOrgan = function (pos) {
    return function (organ) {
        return function (bag) {
            var io = new Data_Tuple.Tuple(organ, pos);
            var coveredPositions = extent(organ)(pos);
            return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (b) {
                return function (v) {
                    return Data_RevMap.insert(Extra_Math.ordVector(Data_Ord.ordInt))(Data_Tuple.ordTuple(ordOrgan)(Extra_Math.ordVector(Data_Ord.ordInt)))(v)(io)(b);
                };
            })(bag)(coveredPositions);
        };
    };
};
var organExtent = function (v) {
    return function (orgs) {
        return Data_Maybe.fromMaybe([  ])(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_RevMap.lookup(Extra_Math.ordVector(Data_Ord.ordInt))(v)(orgs))(function (organ) {
            return Data_RevMap.lookupReverse(Data_Tuple.ordTuple(ordOrgan)(Extra_Math.ordVector(Data_Ord.ordInt)))(organ)(orgs);
        }));
    };
};
var removeOrganAt = function (p) {
    return function (bag) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (b) {
            return function (x) {
                return Data_RevMap["delete"](Extra_Math.ordVector(Data_Ord.ordInt))(Data_Tuple.ordTuple(ordOrgan)(Extra_Math.ordVector(Data_Ord.ordInt)))(x)(b);
            };
        })(bag)(organExtent(p)(bag));
    };
};
var emptyBag = Data_RevMap.empty(Extra_Math.ordVector(Data_Ord.ordInt))(Data_Tuple.ordTuple(ordOrgan)(Extra_Math.ordVector(Data_Ord.ordInt)));
var countIntact = function (f) {
    return function (b) {
        return Data_Array.length(Data_Array.filter(f)(intactOrgans(b)));
    };
};
var hasBlueEye = function (board) {
    return countIntact(isBlueEye)(board) > 0;
};
var hasRedEye = function (board) {
    return countIntact(isRedEye)(board) > 0;
};
var hpCount = countIntact(isHpOrgan);
var canInsertOrgan = function (pos) {
    return function (v) {
        return function (bag) {
            var coveredPositions = extent(v)(pos);
            var lookups = Data_Functor.mapFlipped(Data_Functor.functorArray)(coveredPositions)(function (p) {
                return Data_RevMap.lookup(Extra_Math.ordVector(Data_Ord.ordInt))(p)(bag);
            });
            return !Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Maybe.isJust)(lookups);
        };
    };
};
var armorCount = countIntact(isArmorOrgan);
var fromBoard = function (board) {
    return Health({
        board: board,
        hpCount: hpCount(board),
        armorCount: armorCount(board),
        canSee: hasRedEye(board) || hasBlueEye(board),
        hasSpecialEyes: hasBlueEye(board)
    });
};
var freshHealth = fromBoard({
    injuries: Data_Monoid.mempty(Data_Set.monoidSet(Extra_Math.ordVector(Data_Ord.ordInt))),
    organs: emptyBag
});
var injure = function (v) {
    return function (v1) {
        return fromBoard(injureBoard(v)(v1.board));
    };
};
var injureMulti = function (vs) {
    return function (h) {
        return Data_Foldable.foldr(Data_Foldable.foldableArray)(injure)(h)(vs);
    };
};
var addOrgan = function (pos) {
    return function (organ) {
        return function (v) {
            var newBag = insertOrgan(pos)(organ)(v.board.organs);
            var b$prime = {
                organs: newBag,
                injuries: v.board.injuries
            };
            return fromBoard(b$prime);
        };
    };
};
var addOrgans = function (poss) {
    return function (organ) {
        return function (health) {
            return Data_Foldable.foldr(Data_Foldable.foldableArray)(function (pos) {
                return function (h) {
                    return addOrgan(pos)(organ)(h);
                };
            })(health)(poss);
        };
    };
};
module.exports = {
    OrganSize: OrganSize,
    Hp: Hp,
    PlayerHeartLarge: PlayerHeartLarge,
    HumanEye: HumanEye,
    EyeRed: EyeRed,
    EyeBlue: EyeBlue,
    EyeHoriz: EyeHoriz,
    EyeVert: EyeVert,
    Armor: Armor,
    i: i,
    organImages: organImages,
    Organ: Organ,
    emptyBag: emptyBag,
    insertOrgan: insertOrgan,
    canInsertOrgan: canInsertOrgan,
    removeOrganAt: removeOrganAt,
    organAt: organAt,
    organExtent: organExtent,
    extent: extent,
    organArray: organArray,
    Board: Board,
    injureBoard: injureBoard,
    isValidBoardCoord: isValidBoardCoord,
    getOrganAtPosition: getOrganAtPosition,
    isInside: isInside,
    isHpOrgan: isHpOrgan,
    isArmorOrgan: isArmorOrgan,
    isRedEye: isRedEye,
    isBlueEye: isBlueEye,
    getClue: getClue,
    countIntact: countIntact,
    hpCount: hpCount,
    armorCount: armorCount,
    hasRedEye: hasRedEye,
    hasBlueEye: hasBlueEye,
    intactOrgans: intactOrgans,
    getOrgans: getOrgans,
    HpClue: HpClue,
    ArmorClue: ArmorClue,
    MixedClue: MixedClue,
    ConcealedClue: ConcealedClue,
    EmptyClue: EmptyClue,
    restrictClue: restrictClue,
    randomUninjuredSpace: randomUninjuredSpace,
    randomInjuredSpace: randomInjuredSpace,
    Health: Health,
    freshHealth: freshHealth,
    fromBoard: fromBoard,
    isAlive: isAlive,
    injure: injure,
    isInjured: isInjured,
    validTarget: validTarget,
    injureMulti: injureMulti,
    addOrgan: addOrgan,
    addOrgans: addOrgans,
    eqOrganSize: eqOrganSize,
    ordOrganSize: ordOrganSize,
    eqOrganType: eqOrganType,
    ordOrganType: ordOrganType,
    eqOrgan: eqOrgan,
    ordOrgan: ordOrgan,
    newtypeBoard: newtypeBoard,
    newtypeHealth: newtypeHealth
};
